module.exports = __webpack_public_path__ + "img/google-earth-mission-blue-01.a1e5aae6.jpg";